import React, { ReactNode } from 'react';
import IconStar from '../Rating/IconStar';
import * as S from './styles';
export type RecommendedProps = {
  recommendedBadge?: string;
  recommendedText?: string;
  className?: string;
  children?: ReactNode;
} & S.BadgeProps & S.RecommendedProps;
const Recommended: React.FC<RecommendedProps> = ({
  children,
  recommendedText,
  recommendedBadge,
  badgePosition,
  maxSize,
  margin,
  zIndex
}) => {
  return <>
      {recommendedText && <S.Favorite zIndex={zIndex}>
          <IconStar size={11} />
          {recommendedText}
        </S.Favorite>}
      {children}
      {recommendedBadge && <S.Badge src={recommendedBadge} badgePosition={badgePosition} maxSize={maxSize} margin={margin} zIndex={zIndex} />}
    </>;
};
export default Recommended;